import { Box, Icon, Input, InputGroup, InputLeftElement, Link, VStack } from '@chakra-ui/react'
import React, {useRef} from 'react'
import { graphql, useStaticQuery } from 'gatsby';

import { IconSearch } from '@tabler/icons';
import useAuth from '../hooks/useAuth';
import { useState } from 'react';

export const SearchInput = () => {
  const ref = useRef(null);

  const allProducts = useStaticQuery(graphql`
  {
    allWpProduct {
        nodes {
          name
          slug
          id
          productCategories {
            cat: nodes {
              name
              id
              slug
            }
          }
          productTags {
            nodes {
            name
            }
          }
        }
      }
  }
  `)
  
  const products = allProducts.allWpProduct.nodes

  const [query, setQuery] = useState("")

  const { loggedIn } = useAuth();

  const categoriesToExclude = ["Botulinum Toxins", "Orthopedic Injectables", "Gynecology", "Filler Removal", "Ophthalmology", "Rheumatology"]

  const filteredProducts = React.useMemo(() => {
    let allProducts = products
    if(!loggedIn) {
      allProducts = products.filter((item : any) => {
         return item.productCategories.cat.some(cat => !categoriesToExclude.includes(cat.name)) && !item.productTags?.nodes.some((tag: any) => tag.name === 'unlicensed')
    })
    }


    return allProducts.filter((prod: any) => prod.name.toLowerCase().includes(query))
    },[query, loggedIn])

  return (
    <InputGroup
      id="search"
      flexDirection={{base: "column", md: "ro"}}
    >
      <InputLeftElement>
        <Icon as={IconSearch} color="gray.400" fontSize="lg" />
      </InputLeftElement>
      <Input
        focusBorderColor="blue.500"
        border="1px solid #BAC1CF"
        borderColor="#BAC1CF"
        width="full"
        fontSize="sm"
        variant="filled"
        type="text"
        placeholder="What are you looking for?"
        autoComplete="off"
        background="white"
        _hover={{ bg: "gray.200", cursor: "pointer" }}
        ref={ref}
        
        onChange={(e):any => setQuery(e.target.value)}
      />

      {query == "" ? <></> :
        <Box
          bg="white"
          height="max-content"
          width="100%"
          position={{ base: "relative", md: "absolute" }}
          top={{ base: "0px", md: "40px" }}
          zIndex="9"
          border="1px solid gray"
          borderTop="none"

          maxHeight={{ base: "250px", md: "auto" }}
          overflow={{base: "scroll", md: "auto"}}
        >
          <VStack
            alignItems="flex-start"
            maxHeight={{base: "inherit", md: "auto"}}
          >
        {filteredProducts.length !== 0 ? filteredProducts.map((item: any) => <Link href={`/product/${item.slug}`} key={item.id} width="100%" padding="8px" borderRadius="8px" _hover={{ textDecoration: "none", bg: "gray.100", color: "#dca672", borderRadius: "8px" }}>{item.name}</Link>)
              : <div>Sorry, there were no results for your search.</div>}
        </VStack>
      </Box>}
      
    </InputGroup>
  )
}